import * as React from "react";
import Box from "@mui/material/Box";
import "@fontsource/lato";
import "@fontsource/montserrat";
import {Theme} from "../../Components/styles/styles";
import {ThemeProvider} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import {DEF} from "../../const";
import css from "./AreaAddedReportRow.module.css";
import clsx from "clsx";

export const AreaAddedReportRow = ({
    epid,
    date,
    rowsTotal,
    rowsLoaded,
    rowsError = rowsTotal - rowsLoaded,
}) => {

    const successError = () => {
        if (0 == rowsLoaded || 0 < rowsError) {
            return css.error;
        } else {
            return css.success;
        }
    }

    return (

        <Box className={clsx(css.areaAddedRow, successError())}>
            <ThemeProvider theme={Theme}>

                <Box className={clsx(css.areaAddedRowItemEpid)}>
                    <Typography variant="bodyMediumRegural">Epid</Typography>
                    <Typography variant="bodyMediumBlack">{epid}</Typography>
                </Box>

                <Box className={clsx(css.areaAddedRowItem)}>
                    <Typography variant="bodyMediumRegural">Data importu</Typography>
                    <Typography variant="bodyMediumBlack">{dayjs(date).format(DEF.DATETIME_FORMAT)}</Typography>
                </Box>

                <Box className={clsx(css.areaAddedRowItem)}>
                    <Typography variant="bodyMediumRegural">Wszystkich rekordów</Typography>
                    <Typography variant="bodyMediumBlack">{rowsTotal}</Typography>
                </Box>

                <Box className={clsx(css.areaAddedRowItem)}>
                    <Typography variant="bodyMediumRegural">Rekordy dodane</Typography>
                    <Typography variant="bodyMediumBlack">{rowsLoaded}</Typography>
                </Box>

                <Box className={clsx(css.areaAddedRowItem)}>
                    <Typography variant="bodyMediumRegural">Rekordy błędne</Typography>
                    <Typography variant="bodyMediumBlack">{rowsError}</Typography>
                </Box>

            </ThemeProvider>
        </Box>
    );
};
